import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { ByTheNumbers } from '../components/ByTheNumbers';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-2265">
      <div className="dark" data-id="element-2266">
        <Hero data-id="element-2267" />
      </div>
      <WhyUs data-id="element-2268" />
      <ByTheNumbers data-id="element-2269" />
      <Services data-id="element-2270" />
      <HowItWorks data-id="element-2271" />
      <FAQ data-id="element-2272" />
      <Reviews data-id="element-2273" />
      <CtaBanner data-id="element-2274" />
    </main>;
}